/**
 * Classe responsável por excluir em lotes no grid.
 *
 * @author: Adalto Junior adaltojunior@sagaranatech.com DATE: 30/07/2013
 *
 */

const { checkIfResourceExist } = require("react/utils/utils");


Monet.Grid = Monet.Grid || {};
Monet.Grid.ActionsModules = Monet.Grid.ActionsModules || {};

Monet.Grid.ActionsModules.BatchDelete = (function () {

    BatchDelete.prototype = new Monet.Grid.ActionsModules.ButtonEventCheckBox();

    function BatchDelete() {

      this.setValueBtn = function () {
        this.valueBtn = Monet.I18n.getResourcesByKey("Greenmile.Grid.BatchDelete.btnValue");
      };

      this.actionAfterClickButton = () => {

          try {
            const entityModel = App.Forms[this.entity];
            const grid = entityModel.table;
            const dataProvider = entityModel.dataProvider;

              if (grid !== "undefined") {

                  const rowsSelected = grid.getSelectedRows();
                  const rowsSelectedLength = rowsSelected.length;
                  const idsToDelete = [];

                  if (rowsSelectedLength > 0) {
                      const confirmBatchDelete = () => {
                        for (let i = 0; i < rowsSelectedLength; i++) {
                          const row = dataProvider.getItem(rowsSelected[i]);
                          idsToDelete.push(row.idOfObject);
                        }
                        App.Objects[this.entity].batchDelete(idsToDelete);
                      };

                      const entityLower = String(this.entity).toLowerCase();
                      const alertTitle = `${entityLower}.deleteAlert.title`;
                      const alertMessage = `${entityLower}.deleteAlert.message`;

                      const hasAlertTitle = checkIfResourceExist(alertTitle);
                      const hasAlertMessage = checkIfResourceExist(alertMessage);

                      new Greenmile.Components.AlertModal(
                        hasAlertMessage ?
                          alertMessage : "Greenmile.Grid.BatchDelete.confirmDeletion",
                        hasAlertTitle ?
                          alertTitle : "Greenmile.Grid.BatchDelete.confirmDeletion.header",
                        confirmBatchDelete,
                        null,
                        {
                          isADeleteAction: true,
                          customConfirmButtonResource: hasAlertTitle ? alertTitle : null,
                        }
                        )
                        .show();

                  } else {
                      new Greenmile.Components.AlertModal("Greenmile.actionGridButton.noItemChecked")
                        .show();
                  }

              }

          } catch (e) {
              const error = new Monet.Exception.ReturnError(this,
                  "Error on actionAfter click button.", e);
              error.console();
          }

      };

    }

    return BatchDelete;

})();
